// Event, Dialog
import EventBus from "@/event/EventBus";

// Api
import api from '@/api/baseApi';

// Constant
import { SETTINGS_PROCESS_MONITORING_API } from "@/constant/apiSettings";
import { POPUP_ID } from "@/constant/baseConstant";
import { API_CALL_STATUS } from "@/constant/baseConstant";

// Extend
import baseRentalService from '@/scripts/rentalService/baseRentalService';
const queryString = require('query-string');
export default {

    extends: baseRentalService,

    data() {

        return {
            intervalReload: null,
            isActionExecuting: false,
            processMonitorData: {
                isEnabled: false,
                listProcessBeMonitored: []
            },
            
        };
    },

    props: {
        targetImage: {
            type: Object,
            default: null, 
        },
    },

    watch: {
        targetImage: {
            handler(newval) {
                if (this.targetImage != null) this.loadProcessList();
            },
            deep: true
        }
    },
    mounted() {
        if (this.targetImage != null) this.loadProcessList();
        this.intervalReload = setInterval(() => {
            if(!this.isActionExecuting){
                this.loadProcessList(false);
            }
        }, 5000);
    },
    beforeDestroy() {
        clearInterval(this.intervalReload);
    },
    methods: {

        // Close this pop-up
        closeThisPopup() {
            this.closePopup(POPUP_ID.PROCESS_MONITORING);
        },

        //#region Hardware fixation
        loadProcessList(isShowLoading = true) {
            if(isShowLoading) this.feedStatusLoading(API_CALL_STATUS.LOADING);
            setTimeout(() => {
                let data = {
                    machineId: this.targetImage.id,
                    deviceInformation: JSON.stringify(this.getInformationClient())
                }
                let queryParams = queryString.stringify(data);
                api.baseRequest(SETTINGS_PROCESS_MONITORING_API.VIEW, null, `?${queryParams}`)
                    .then((response) => {
                        this.feedStatusLoading(API_CALL_STATUS.SUCCESS);
                        this.processMonitorData.isEnabled = response.data.isProcessMonitorEnabled;
                        this.processMonitorData.listProcessBeMonitored = response.data.processList;
                    })
                    .catch(error => {
                        //this.processCatchApiRequest(error, "Load Process List failed ...")
                    });
            }, this.smoothTimeOut);
        },
        removeProcess(itemProcess) {
            this.isActionExecuting = true;
            this.$confirm(this.$t('processMonitoringModal.removeConfirmMessage', { name: itemProcess.friendlyName }), this.$t('processMonitoringModal.removeConfirmTitle'), {
                confirmButtonText: this.$t('processMonitoringModal.ok'),
                cancelButtonText: this.$t('processMonitoringModal.cancel'),
                type: 'warning'
            }).then(() => {
                this.feedStatusLoading(API_CALL_STATUS.LOADING);
                let data = {
                    machineId: this.targetImage.id,
                    itemId: itemProcess.id,
                    deviceInformation: JSON.stringify(this.getInformationClient())
                }
                api.baseRequest(SETTINGS_PROCESS_MONITORING_API.REMOVE, data)
                    .then((response) => {
                        this.loadProcessList();
                        this.$message({
                            type: 'success',
                            message: this.$t('processMonitoringModal.removeCompleted')
                        });
                        this.isActionExecuting = false;
                    })
                    .catch(error => {
                        this.isActionExecuting = false;
                        this.processCatchApiRequest(error, this.$t('processMonitoringModal.removeFailed'))
                    });
            }).catch(() => {
                this.isActionExecuting = false;
            });
        },
        toogleEnableMonitor(newVal) {
            this.isActionExecuting = true;
            this.feedStatusLoading(API_CALL_STATUS.LOADING);
            let data = {
                machineId: this.targetImage.id,
                isEnabled: newVal,
                deviceInformation: JSON.stringify(this.getInformationClient())
            }
            api.baseRequest(SETTINGS_PROCESS_MONITORING_API.ENABLE, data)
                .then((response) => {
                    this.$message({
                        type: 'success',
                        message: this.$t(newVal ? 'processMonitoringModal.monitorEnabled' : 'processMonitoringModal.monitorDisabled')
                    });
                    this.loadProcessList();
                })
                .catch(error => {
                    this.isActionExecuting = false;
                    this.processCatchApiRequest(error, this.$t('processMonitoringModal.enableFailed'))
                });
        }
        //#endregion 
    },
}